Alpine.data('alpine_showrooms', () => ({
  error: null,
  formData: {
    showroom_id: null,
    from_name: '',
    from_email: '',
    message: '',
  },
  message_sent: false,
  open: false,
  sending: false,
  showroom: {
    address1: '',
    address2: null,
    city: '',
    phone: '',
    postal_code: '',
    state_province: '',
    location: '',
    name: '',
  },

  closeContact() {
    if(this.sending) {
      return;
    }

    this.open = false;
    this.message_sent = false;
    this.error = null;

    this.formData = {from_name: '', from_email: '', message: '', showroom_id: null};
  },

  async sendMessage(e) {
    this.error = null;
    this.sending = true;

    await window.axios
      .post(e.target.getAttribute('action'), this.formData)
        .then(response => this.message_sent = true)
        .catch(error => {
          window.console.error(error);

          this.error = "There was a problem sending your message. Please try again.";
        })
        .finally(() => this.sending = false);
  },

  init() {
    this.$watch('open', value => document.body.classList.toggle('overflow-hidden', value));
  },
}));
